import { PdLogoLoader } from "./pd-logo-loader.js";
//#region src/pd-loading-state/register-pd-logo-loader.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
var tag = "pd-logo-loader";
if (!customElements.get(tag)) customElements.define(tag, PdLogoLoader);
//#endregion
